<template>
  <canvas id="preview-watermark-self" ref="watermark"></canvas>
</template>
<script>
const defaultOptions = {
  fontSize: '16',
  fontFamily: 'serif',
  text: ['admin'],
  angle: Math.PI / 6,
  marginRight: 50,
  marginBottom: 75,
  transparency: '0.5',
  color: '#000000'
}
export default {
  props: {
    watermarkInfo: Object
  },
  data () {
    return {}
  },
  mounted () {
    this.draw()
  },
  methods: {
    normalizeOptions (options) {
      const safeOptions = options && typeof options === 'object' ? options : {}
      return Object.keys(defaultOptions).reduce((acc, key) => {
        acc[key] = safeOptions[key] == null ? defaultOptions[key] : safeOptions[key]
        return acc
      }, { ...safeOptions })
    },
    draw () {
      var canvas = this.$refs.watermark
      if (!canvas) return
      try {
        const styles = window.getComputedStyle(canvas)
        canvas.width = parseFloat(styles.width)
        canvas.height = parseFloat(styles.height)
        this.watermark(canvas, {
          fontSize: this.watermarkInfo.font_size,
          text: this.watermarkInfo.content || [],
          marginRight: 70,
          marginBottom: 95,
          transparency: this.watermarkInfo.opacity,
          color: this.watermarkInfo.font_color,
          spacing: this.watermarkInfo.lineDistance || 5
        })
      } catch (e) {
        console.log(e)
      }
    },
    watermark (canvas, options = {}) {
      options = this.normalizeOptions(options)

      const { angle } = options

      const ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.globalAlpha = options.transparency

      const textCanvas = this.createTextCanvas(options)

      ctx.rotate(-angle)
      const pattern = ctx.createPattern(textCanvas, 'repeat')
      ctx.fillStyle = pattern

      // 补全倾斜后的空白
      const deltaX = Math.sin(angle) * canvas.height
      const deltaY = Math.tan(angle) * canvas.width
      ctx.fillRect(-deltaX, 0, canvas.width + deltaX, canvas.height + deltaY)
    },
    createTextCanvas (options) {
      const {
        fontSize,
        text,
        color,
        fontFamily,
        spacing
      } = options
      const textCanvas = document.createElement('canvas')
      const textCtx = textCanvas.getContext('2d')
      textCtx.font = fontSize + 'px serif'

      // 遍历text数组,获取最大的宽度
      let textWidth
      text.forEach(str => {
        const { width } = textCtx.measureText(str)
        if (!textWidth || width > textWidth) {
          textWidth = width
        }
      })
      const textHeight = parseInt(fontSize) * 1.2
      const textSpacing = (spacing + text.length) * fontSize
      textCanvas.width = textWidth + textSpacing
      textCanvas.height = textHeight + textSpacing
      textCtx.font = fontSize + 'px ' + fontFamily
      textCtx.fillStyle = color
      textCtx.translate(0, textHeight)

      text.forEach((_t, i) => {
        textCtx.fillText(_t, i * textHeight, i * textHeight)
      })
      return textCanvas
    }
  }
}
</script>
<style lang="postcss">
#preview-watermark-self {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  pointer-events: none;
  z-index: 1000;
}
</style>
